/**
 * Circular spinning Energy Matcher badge.
 * Uses SVG text on path for true curved text + CSS spin animation.
 */
export default function SpinningBadge({
    size = 160,
    text = "ENERGY MATCHER · FW/25 · ENERGY MATCHER · FW/25 · ",
    className = "",
    invert = false,
    duration = 14,
}) {
    const fg = invert ? "#050505" : "#FAFAFA";
    const bg = invert ? "#FAFAFA" : "transparent";

    return (
        <div
            className={`relative inline-block ${className}`}
            style={{ width: size, height: size }}
            data-testid="spinning-badge"
            data-cursor="hover"
            data-cursor-label="·EM·"
        >
            <svg
                viewBox="0 0 200 200"
                width={size}
                height={size}
                style={{
                    animation: `em-spin ${duration}s linear infinite`,
                    transformOrigin: "center",
                }}
                aria-hidden="true"
            >
                <defs>
                    <path
                        id="em-circle"
                        d="M100,100 m-78,0 a78,78 0 1,1 156,0 a78,78 0 1,1 -156,0"
                    />
                </defs>
                {bg !== "transparent" && (
                    <circle cx="100" cy="100" r="92" fill={bg} />
                )}
                <text
                    fill={fg}
                    style={{
                        fontFamily: "JetBrains Mono, monospace",
                        fontSize: "14px",
                        letterSpacing: "0.18em",
                        textTransform: "uppercase",
                        fontWeight: 500,
                    }}
                >
                    <textPath href="#em-circle" startOffset="0">
                        {text}
                    </textPath>
                </text>
            </svg>

            {/* Static center mark */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div
                    className="flex flex-col items-center justify-center text-center"
                    style={{ color: fg }}
                >
                    <span className="block w-2 h-2 bg-current mb-1" />
                    <span
                        className="font-display italic leading-none"
                        style={{ fontSize: size * 0.18 }}
                    >
                        EM
                    </span>
                    <span className="block w-2 h-2 bg-current mt-1" />
                </div>
            </div>

            <style>{`
                @keyframes em-spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}
